/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';

/**
 * A global HS tariff line (Jamaica integrated tariff). Rates are fractions: 0.2 = 20%.
 * Read by everyone; written only by Overlord.
 */
export interface TariffCode {
    id?: number;
    /** 10-digit HS code, e.g. "8517130000". */
    tariffCode: string;
    description?: string;
    /** Parent heading text, so "Other" rows read in context. */
    headingDescription?: string | null;
    /** Comma-separated everyday shopping words matched by search. */
    keywords?: string | null;
    chapter?: string;
    heading?: string;
    subheading?: string;
    importDutyRate?: number;
    gctRate?: number;
    scfRate?: number;
    environmentalLevy?: number;
    exciseDuty?: number;
    units?: string;
    isActive?: boolean;
    needsReview?: boolean;
    manuallyEditedAt?: Date | null;
    createdAt?: Date;
    updatedAt?: Date;
}

function toDate(v: any): Date | undefined | null {
    if (v === null) return null;
    return v == null ? undefined : new Date(v);
}

function toIso(v: Date | null | undefined): string | null | undefined {
    if (v === undefined) return undefined;
    if (v === null) return null;
    return v instanceof Date ? v.toISOString() : v;
}

export function TariffCodeFromJSON(json: any): TariffCode {
    return TariffCodeFromJSONTyped(json, false);
}

export function TariffCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TariffCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tariffCode': json['tariffCode'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'headingDescription': !exists(json, 'headingDescription') ? undefined : json['headingDescription'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'chapter': !exists(json, 'chapter') ? undefined : json['chapter'],
        'heading': !exists(json, 'heading') ? undefined : json['heading'],
        'subheading': !exists(json, 'subheading') ? undefined : json['subheading'],
        'importDutyRate': !exists(json, 'importDutyRate') ? undefined : json['importDutyRate'],
        'gctRate': !exists(json, 'gctRate') ? undefined : json['gctRate'],
        'scfRate': !exists(json, 'scfRate') ? undefined : json['scfRate'],
        'environmentalLevy': !exists(json, 'environmentalLevy') ? undefined : json['environmentalLevy'],
        'exciseDuty': !exists(json, 'exciseDuty') ? undefined : json['exciseDuty'],
        'units': !exists(json, 'units') ? undefined : json['units'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'needsReview': !exists(json, 'needsReview') ? undefined : json['needsReview'],
        'manuallyEditedAt': !exists(json, 'manuallyEditedAt') ? undefined : toDate(json['manuallyEditedAt']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (toDate(json['createdAt']) as Date),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (toDate(json['updatedAt']) as Date),
    };
}

export function TariffCodeToJSON(value?: Partial<TariffCode> | null): any {
    return TariffCodeToJSONTyped(value, false);
}

export function TariffCodeToJSONTyped(value?: Partial<TariffCode> | null, ignoreDiscriminator: boolean = false): any {
    if (value === undefined) { return undefined; }
    if (value === null) { return null; }
    return {
        'tariffCode': value.tariffCode,
        'description': value.description,
        'headingDescription': value.headingDescription,
        'keywords': value.keywords,
        'chapter': value.chapter,
        'heading': value.heading,
        'subheading': value.subheading,
        'importDutyRate': value.importDutyRate,
        'gctRate': value.gctRate,
        'scfRate': value.scfRate,
        'environmentalLevy': value.environmentalLevy,
        'exciseDuty': value.exciseDuty,
        'units': value.units,
        'isActive': value.isActive,
        'needsReview': value.needsReview,
        'manuallyEditedAt': toIso(value.manuallyEditedAt),
    };
}
